import React, { useContext } from "react";
import styles from "./styles.module.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { AppContext } from "../../AppContext";

export const ToggleRightNav = (props) => {
  const appContext = useContext(AppContext);
  const { hideRightNav, setHideRightNav } = appContext;
  return (
    <div
      onClick={() => setHideRightNav(!hideRightNav)}
      className={styles.closeNavIconContainer}
      style={{ right: hideRightNav ? 10 : 160 }}
    >
      {hideRightNav ? (
        <FaAngleLeft size={26} color="#36454f" />
      ) : (
        <FaAngleRight size={26} color="#36454f" />
      )}
    </div>
  );
};
